<template>
  <div>
    <!-- <div class="my-info-update-page">
    <div class="title">请上传本人的证件照</div>
    <div class="content">信息通过后不可更改</div>
    <div class="active-block">
      <div>
        <img src="../../images/icon/3.png" alt="" />
      </div>
      <div>
        <img src="../../images/icon/4.png" alt="" />
      </div>
    </div>
    <div class="button">验证信息</div>
  </div> -->


    <div class="my-info-update-page">
      <div class="stepStyle">第一步：</div>
      <div class="title">请确保注册时个人信息正确</div>
      <div class="content">信息通过后不可更改</div>
      <!-- <div class="content">姓名：{{}}</div>
    <div class="content"></div> -->

         <div class="active-block">
        <div class="content-line">请上传本人的证件照</div>
        <div>
          <!-- <img src="../../images/icon/3.png" alt="" /> -->
          <!-- <el-upload
            class="avatar-uploader"
            :action="active_url"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="ZimageUrl" :src="ZimageUrl" class="avatar" />
            <img v-else src="../../images/icon/3.png" class="avatar" />
          </el-upload> -->

          <!-- <input type="file" accept="image/*" > -->

          <van-uploader class="avatar-uploader" :after-read="afterRead_Z">
            <img v-if="ZimageUrl" :src="ZimageUrl" class="avatar" />
            <img v-else src="../../images/icon/3.png" class="avatar" />
          </van-uploader>
        </div>

        <div>
          <!-- <el-upload
            class="avatar-uploader"
            :action="active_url_F"
            :show-file-list="false"
            :on-success="F_handleAvatarSuccess"
            :before-upload="F_beforeAvatarUpload"
          >
            <img v-if="FimageUrl" :src="FimageUrl" class="avatar" />
            <img v-else src="../../images/icon/4.png" class="avatar" />
          </el-upload> -->
          <!-- <img src="../../images/icon/4.png" alt="" /> -->
          <van-uploader class="avatar-uploader" :after-read="afterRead_F">
            <img v-if="FimageUrl" :src="FimageUrl" class="avatar" />
            <img v-else src="../../images/icon/4.png" class="avatar" />
          </van-uploader>
        </div>
        <div></div>
      </div>



            <div class="prompt">
        *为保证您的权益，请确认下列“姓名”及“身份证号”为本人信息，若存在错误请点击信息进行修改。
      </div>

      <div class="rz-block">
        <div class="line-block">
          <div class="line-block-pram">
            <img class="card-icon-img" src="../../images/icon/2.png" alt="" />
            <div class="lx-font">实名认证信息</div>
          </div>
          <div class="line-text">
            <!-- <div>姓名：{{ userInfo.name }}</div> -->
            <div>
              <van-field
                v-model="userInfo.name"
                label="姓名："
                placeholder="请输入用户名"
              />
            </div>
          </div>
          <div class="line-text">
            <van-field
              v-model="userInfo.id_number"
              label="身份证号："
              placeholder="请输入请输入身份证号"
            />
            <!-- <div>身份证号：{{ userInfo.id_number }}</div> -->
          </div>
          <div class="line-text">
            <van-field
              readonly
              label="手机号："
              :placeholder="userInfo.phone"
            />
            <!-- <div>手机号：{{ userInfo.phone }}</div> -->
          </div>
          <div v-if="!registeredType" class="success_button" @click="up_userinfo()">确认个人信息</div>
          <div v-if="registeredType" class="success_button" @click="up_userinfo()">修改个人信息</div>
        </div>
      </div>

      <div class="stepStyle">第二步：</div>

      <div class="prompt">
        *为保证您的权益，手机号实名认证需要实名认证的注册手机号为本人实名开通;若手机实名认证失败请选择人脸实名认证。
      </div>

      <div v-if="registeredType">

      <div class="button" @click="RZ()">手机号实名认证</div>
      <div class="button" @click="RLRZ()">人脸实名认证</div>
      </div>

         <div v-if="!registeredType">

      <div class="button buttonError" @click="showError()">手机号实名认证</div>
      <div class="button buttonError" @click="showError()">人脸实名认证</div>
      </div>

      <div class="prompt" v-if="show_certificate">
        *数字证书与实名认证申请成功
      </div>
    </div>
    <van-dialog
      v-model="isShow"
      show-cancel-button
      :before-close="beforeClose"
      confirm-button-text="下一步"
    >
      <div v-if="company == ''">
        <ComponentA></ComponentA>
      </div>
      <div v-else>
        <ComponentB></ComponentB>
      </div>
    </van-dialog>
    <van-dialog
      v-model="phoneisShow"
      :show-cancel-button="false"
      :show-confirm-button="false"
      :before-close="phonebeforeClose"
      confirm-button-text="确认"
    >
      <div class="dialog-block">
        <div class="line-block-phone">
          <div class="line-block-phone-title">手机验证</div>
          <div class="line-block-phone-input">
            <div class="tishi" style="margin-bottom: 0.2rem">
              *请首先点击获得验证码，获得验证码后填入验证码，进行实名认证的操作
            </div>
            <div class="input-block">
              <el-input
                v-model="input_phone_code"
                placeholder="请输入验证码"
                maxlength="6"
              ></el-input>
              <el-button
                v-if="activeshow"
                class="input-button"
                type="success"
                @click="huode_code()"
                >{{ showcodetext }}</el-button
              >
              <el-button
                v-if="!activeshow"
                class="input-button"
                type="success"
                @click="huode_code()"
                :disabled="true"
                >重新发送{{ count }}秒</el-button
              >
            </div>
            <div class="rm-code">
              <el-button
                class="sm-button"
                type="success"
                @click="yanzheng_code()"
                >确认</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import actions from "../../common/test.js";
import util from "../../common/util.js";
import axios from "axios";
import { Dialog } from "vant";
import { ref } from "vue";
import ComponentA from "./3ctext_jxzf.vue";
import ComponentB from "./3ctext_jcfy.vue";
export default {
  setup() {
    const show = ref(false);
    return { show };
  },
  components: {
    ComponentA,
    ComponentB,
  },
  data() {
    return {
      userInfo: {},
      ZimageUrl: "",
      FimageUrl: "",
      // active_url:
      //   "http://test.jcfyht.cc/Contract/api/capi?api_name=uploadsfz&pic_type=sfzzm&token=clientjcfy&gzhid=" +
      //   util.getLocalStorage("openid"),
      active_url_F:
        "http://wx.jcfyht.cc/Contract/api/capi?api_name=uploadsfz&pic_type=sfzfm&token=clientjcfy&gzhid=" +
        util.getLocalStorage("openid"),
      isShow: false,
      phoneisShow: false,
      show_certificate: false,
      isShowSuccess: true,
      company: "",
      input_phone_code: "",
      activeshow: true,
      showcodetext: "获得验证码",
      isactive: false,
      count: "",
      timer: null,
      registeredType:false
    };
  },
  created() {
    this.$store.commit("changeTitle", "实名认证");
    util.hideLoading();
  },
  mounted() {
    this.getuserinfo();
    this.company = util.getLocalStorage("company");
    // alert(this.company);
  },
  updated() {},
  computed: {},
  watch: {},
  methods: {
    getuserinfo() {
      let data = {
        gzhid: util.getLocalStorage("openid"),
        //gzhid: "ovgmM0756koHNWHF8vDXJXQA9kqE",
      };
      actions.getuser_info(data).then((res) => {
        console.log(res);
        if (res.is_success == "yes") {
          let length = res.content.length - 1;
          this.userInfo = res.content[length];
          util.setLocalStorage("phone", this.userInfo.phone || "");
          util.setLocalStorage("name", this.userInfo.xingming);
        }
      });
    },
    afterRead_Z(file) {
      // 此时可以自行将文件上传至服务器
      this.ZimageUrl = URL.createObjectURL(file.file);
      var info = new FormData();
      info.append("sfz", file.file);
      axios({
        method: "post",
        // url:
        //   "http://test.jcfyht.cc/Contract/api/capi?api_name=uploadsfz&pic_type=sfzzm&token=clientjcfy&gzhid=" +
        //   util.getLocalStorage("openid"),
           url:
          "http://wx.beijinghome.cc/Contract/api/capi?api_name=uploadsfz&pic_type=sfzzm&token=clientjcfy&gzhid=" +
          util.getLocalStorage("openid"),
        data: info,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
    },
    afterRead_F(file) {
      // 此时可以自行将文件上传至服务器
      this.FimageUrl = URL.createObjectURL(file.file);
      var info = new FormData();
      info.append("sfz", file.file);
      axios({
        method: "post",
        // url:
        //   "http://test.jcfyht.cc/Contract/api/capi?api_name=uploadsfz&pic_type=sfzfm&token=clientjcfy&gzhid=" +
        //   util.getLocalStorage("openid"),
            url:
          "http://wx.beijinghome.cc/Contract/api/capi?api_name=uploadsfz&pic_type=sfzfm&token=clientjcfy&gzhid=" +
          util.getLocalStorage("openid"),
        data: info,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
    },
    RZ() {
      if (this.ZimageUrl == "") {
        this.$message.error("请上传身份证正面照");
        return false;
      }
      if (this.ZimageUrl == "") {
        this.$message.error("请上传身份证反面照");
        return false;
      }

      let data = {
        gzhid: util.getLocalStorage("openid"),
        //gzhid: "ovgmM0756koHNWHF8vDXJXQA9kqE",
      };
      actions.getuser_info(data).then((res) => {
        console.log(res);
        if (res.is_success == "yes") {
          let length = res.content.length - 1;
          this.userInfo = res.content[length];
          if (this.userInfo.id_number == "") {
            Dialog.alert({
              message: "请先进行个人信息确认",
            }).then(() => {});
          } else {
            this.isShow = true;
            this.RZ_type = "RZ";
          }
        }
      });
    },
    RZ_active() {
      this.isShow = false;
      this.phoneisShow = true;
    },
    showError(){
       Dialog.alert({
            title: "提示",
            message: "请点击“确认个人信息”按钮来确认本人信息",
          })
    },
    yanzheng_code() {
      if (this.get_info == "") {
        this.$message.error("请先获得验证码");
        return false;
      }
      if (this.input_phone_code == "") {
        this.$message.error("请先输入验证码");
        return false;
      }
      let data = {
        gzhid: util.getLocalStorage("openid"),
        key: this.get_info,
        code: this.input_phone_code,
      };
      actions.phone_validation_shiming(data).then((info) => {
        if (info.is_success == "yes") {
          this.show_certificate = true;
          Dialog.alert({
            title: "认证成功",
            message: "CA证书申请成功且存储在上上签。",
          }).then(() => {
            let data = {
              gzhid: util.getLocalStorage("openid"),
              //gzhid:'ovgmM0756koHNWHF8vDXJXQA9kqE'
            };
            actions.user_RZ(data).then((res) => {
              if (res.is_success == "yes") {
                alert("认证成功");
                this.$router.push({ name: "personcenter" });
              } else {
                alert("认证失败");
              }
            });
          });
        } else {
          Dialog.alert({
            title: "认证失败",
            message: "请重新认证",
          }).then(() => {});
        }
      });
    },
    RLRZ() {
      if (this.ZimageUrl == "") {
        this.$message.error("请上传身份证正面照");
        return false;
      }
      if (this.ZimageUrl == "") {
        this.$message.error("请上传身份证反面照");
        return false;
      }

      let data = {
        gzhid: util.getLocalStorage("openid"),
        //gzhid: "ovgmM0756koHNWHF8vDXJXQA9kqE",
      };
      actions.getuser_info(data).then((res) => {
        console.log(res);
        if (res.is_success == "yes") {
          let length = res.content.length - 1;
          this.userInfo = res.content[length];
          if (this.userInfo.id_number == "") {
            Dialog.alert({
              message: "请先进行个人信息确认",
            }).then(() => {});
          } else {
            this.isShow = true;
            this.RZ_type = "RLRZ";
          }
        }
      });
    },
    RLRZ_actyive() {
      let data = {
        gzhid: util.getLocalStorage("openid"),
        //gzhid:'ovgmM0zXmWyAwPt988pTqmDxZtqs'
      };
      actions.user_RLRZ(data).then((res) => {
        if (res.is_success == "yes" && res.content.indexOf("https") != -1) {
          //window.open(res.content);
          window.location.replace(res.content);
          //this.$router.push({ name: "personcenter" });
        } else {
          alert("认证失败,请联系技术人员");
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.ZimageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      // // const isJPG = file.type === "image/jpeg";
      // const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      // if (!isLt2M) {
      //   this.$message.error("上传头像图片大小不能超过 2MB!");
      // }
      // return isJPG && isLt2M;
      return true;
    },
    F_handleAvatarSuccess(res, file) {
      console.log(file);
      this.FimageUrl = URL.createObjectURL(file.raw);
    },
    F_beforeAvatarUpload(file) {
      // const isJPG = file.type === "image/jpeg";
      // const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      // if (!isLt2M) {
      //   this.$message.error("上传头像图片大小不能超过 2MB!");
      // }
      // return isJPG && isLt2M;
      return true;
    },

    beforeClose(action, done) {
      if (action === "confirm") {
        if (this.RZ_type == "RZ") {
          this.RZ_active();
          // this.show_certificate = true;
          // Dialog.alert({
          //   title: "认证成功",
          //   message: "CA证书申请成功且存储在上上签。",
          // }).then(() => {
          //   this.RZ_active();
          // });
        } else if (this.RZ_type == "RLRZ") {
          this.show_certificate = true;
          this.RLRZ_actyive();
        }
        this.isShow = false;
      } else if (action === "cancel") {
        console.log("2");
        done(); // 关闭
      }
    },
    phonebeforeClose(action, done) {
      // if (action === "confirm") {
      //   if (this.RZ_type == "RZ") {
      //     this.show_certificate = true;
      //     Dialog.alert({
      //       title: "认证成功",
      //       message: "CA证书申请成功且存储在上上签。",
      //     }).then(() => {});
      //   }
      //   this.phoneisShow = false;
      // } else if (action === "cancel") {
      //   console.log("2");
      //   done(); // 关闭
      // }
    },
    up_userinfo() {
      let data = this.userInfo;
      console.log(data)
        if (data.name == "") {
        Dialog({ message: "请输入姓名" });
         return
      }
      if (data.id_number == "") {
        Dialog({ message: "请输入身份证号" });
        return
      }


      let info = {
        name: data.name,
        id_number: data.id_number,
        phone: data.phone,
        gzhid: util.getLocalStorage("openid"),
      };
      actions.registered_active(info).then((res) => {
        this.registeredType = true
        Dialog({ message: "实名信息登记成功" });
      });
    },
    showactivetext() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.activeshow = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.activeshow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    huode_code() {
      let data = {
        gzhid: util.getLocalStorage("openid"),
      };
      actions.phone_validation(data).then((info) => {
        if (info.is_success == "yes") {
          this.get_info = info.content;
          this.showactivetext();
        } else {
          this.phoneisShow = false;
          // this.$message.error(
          //   "获取验证码失败，请检查身份证信息和手机号码是否准确！"
          // );
          Dialog.alert({
            message: "获取验证码失败，请检查身份证信息和手机号码是否准确！",
          }).then(() => {
            // on close
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.my-info-update-page {
  position: relative;
  color: #333333;
  // background: #ffffff;
  min-height: 100vh;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  .title {
    margin-top: 0.5rem;
    text-align: center;
    font-size: 0.4rem;

    font-weight: 600;
  }
  .content {
    margin-top: 0.23rem;
    text-align: center;
    font-size: 0.24rem;
    margin-bottom: 0.13rem;
  }
  .content-line {
    margin-top: 0.43rem;
    text-align: center;
    font-size: 0.24rem;
    margin-bottom: 0.13rem;
  }
  .active-block {
    img {
      display: block;
      margin: 0 auto;
      width: 5.38rem;
      margin-top: 0.5rem;
    }
  }
  .button {
    width: 6.7rem;
    height: 0.8rem;
    border-radius: 0.2rem;
    background: #ecb94c;
    text-align: center;
    line-height: 0.8rem;
    color: #ffffff;
    font-size: 0.32rem;
    font-weight: 600;

    margin: 0 auto;
    margin-top: 0.67rem;
  }
  .buttonError{
    background: #d3d3d3;
  }
  .stepStyle{
  padding-left: 0.3rem;
  font-weight: bold;
}
}
.rz-block {
  margin-top: 0.3rem;
  margin-bottom: 0.6rem;
  .line-block {
    width: 6.7rem;
    background: #ffffff;
    box-shadow: 0rem 0rem 0.06rem #d3d3d3;
    margin: 0 auto;
    border-radius: 0.08rem;
    padding: 0.3rem;

    .line-block-pram {
      display: flex;
      align-items: center;
      justify-content: start;
      margin-bottom: 0.3rem;
    }
    .line-text {
      line-height: 0.8rem;
    }

    .card-icon-img {
      width: 0.7rem;
      margin: 0 0.3rem 0 0;
    }
    .card-text {
      width: 4rem;
      height: 1.4rem;

      .lx-font {
        font-size: 0.32rem;
        font-weight: 600;
        line-height: 0.65rem;
        margin-top: 0.1rem;
        display: inline-block;
      }
      .s-font {
        font-size: 0.2rem;
      }
    }
    .card-statu {
      margin-right: 0.2rem;
      width: 1.1rem;
      .statu-text {
        color: #ecb94c;
        font-size: 0.3rem;
      }
    }
  }
}
.avatar-uploader {
  width: 100%;
  text-align: center;
}
.avatar-uploader /deep/ .van-uploader__input-wrapper {
  margin: 0 auto;
}
.avatar {
  width: 5.38rem;
  height: 3.28rem;
}
.prompt {
  padding: 0 0.4rem;
  font-size: 0.2rem;
  line-height: 0.4rem;
  margin-top: 0.3rem;
  color: #f60;
}
.success_button {
  margin: 0 auto;
  background: #ecb94c;
  color: #ffffff;
  text-align: center;
  padding: 10px 20px;
}
.dialog-block {
  /deep/ .line-block-phone {
    background: #ffffff;
    box-shadow: 0rem 0rem 0.06rem #d3d3d3;
    margin: 0 auto;
    border-radius: 0.08rem;

    padding: 0.3rem 0.23rem;
    .line-block-phone-title {
      font-size: 0.26rem;
      font-weight: 600;
      margin-bottom: 0.2rem;
    }
    .tishi {
      font-size: 0.2rem;
      line-height: 0.4rem;
      margin-top: 0.3rem;
      color: #f60;
    }
    .id-style {
      font-size: 0.2rem;
      line-height: 0.4rem;
    }
    .input-block {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .input-button {
        margin-left: 0.1rem;
      }
    }
    .p-code {
      margin-top: 0.2rem;
    }
    .rm-code {
      margin-top: 0.3rem;
      width: 100%;
      .sm-button {
        width: 100%;
      }
    }
  }
}

</style>

